export const verbiage = {
  // SELECT FULFILLMENT
  SELECT_FULFILLMENT_TITLE: 'Which type of gift card do you want to send?',
  EMAIL_TILE: 'Digital',
  EMAIL_SUBTITLE: 'Send it instantly or on a specific date for free.',
  EMAIL_FOOTER: '(Select date/time during checkout)',
  SHIP_TITLE: 'Physical',
  SHIP_SUBTITLE: 'Send a traditional gift card through the mail. Flexible shipping options available.',
  SHIP_FOOTER: '(Select shipping during checkout)',
  USE_A_SET_AMOUNT: 'Use a Set Amount',
  ENTER_A_CUSTOM_AMOUNT: 'Enter a Custom Amount'
}

export const fulfillments = {
  EMAIL_IT: 'DIGITAL',
  DIGITAL: 'DIGITAL',
  SHIP_IT: 'PHYSICAL',
  PHYSICAL: 'PHYSICAL'
}

export const giftCardAmounts = [
  '25',
  '50',
  '100',
  '200',
  '250',
  '500',
  '1000',
  '2000'
]

export const giftCardMallAmounts = [
  15,
  25,
  50,
  100,
  200,
  250,
  500,
  1000,
  2000
]

export const newRelicMask = {
  message: '#####',
  senderName: '#####',
  recipientName: '#####',
  recipientEmail: '#####'
}

export const staticPageUrls = {
  home: {
    url: '/',
    name: 'Home',
    label: 'home'
  },
  landing: {
    url: '/c/gift-cards',
    name: 'Gift Cards',
    label: 'landing'
  },
  thirdParty: {
    url: '/gift-cards/specialty-cards',
    name: 'Specialty Gift Cards',
    label: 'specialty-cards'
  },
  balanceReload: {
    url: '/gift-cards/balance',
    name: 'Check Balance and Reload',
    label: 'Balance and Reload'
  },
  list: {
    url: '/gift-cards/list',
    name: 'Gift Cards',
    label: 'gift-cards'
  },
  auth: {
    url: '/auth/view/signin?redirect=/gift-cards/balance/ ',
    name: 'Sign In'
  }
};

export const FEATURE_SWITCH_NAMES = {
  DISABLE_GIFT_CARD_PURCHASE: 'disableGiftCardPurchase',
  DISABLE_GIFT_CARD_CHECK_BALANCE_AND_RELOAD: 'disableGiftCardCheckbalanceAndReload',
};
